"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;

var _utils = require("../../../utils");

var _const = require("../../../const");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var modalSize = function modalSize(measure) {
  switch (measure) {
    case 'sm':
      return (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        ", " {\n          max-width: 300px;\n        }\n      "])), _const.GridBreakpointsMediaUp.sm);

    case 'md':
      return (0, _utils.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        max-width: 500px;\n      "])));

    case 'lg':
      return (0, _utils.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        ", " {\n          max-width: 800px;\n        }\n      "])), _const.GridBreakpointsMediaUp.lg);

    case 'xl':
      return (0, _utils.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        ", " {\n          max-width: 800px;\n        }\n        ", " {\n          max-width: 1140px;\n        }\n      "])), _const.GridBreakpointsMediaUp.lg, _const.GridBreakpointsMediaUp.xl);

    case 'full':
      return (0, _utils.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        width: 100%;\n        height: 100%;\n        max-height: 100%;\n        max-width: 100%;\n      "])));
  }

  return (0, _utils.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    ", " {\n      max-width: 500px;\n    }\n  "])), _const.GridBreakpointsMediaUp.sm);
};

var Dialog = (0, _utils.styled)('div')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 0;\n  width: 100%;\n  overflow: hidden;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: 0 auto;\n  ", ";\n"])), _const.Colors.white, function (_ref) {
  var measure = _ref.measure;
  return modalSize(measure);
});
exports.Dialog = Dialog;